export const BACKOFFICE_ORGANIZATIONS_MONITORING = {
  TITLE: 'Monitoring configuration',
  DESCRIPTION:
    'Configure the OpenSearch dashboards, installer file, and signing credentials for this organization. Only visible to superadmins.',
  FIELDS: {
    EVENT_STATISTICS_URL: {
      LABEL: 'Event statistics URL',
      PLACEHOLDER: 'https://…?auth_token={TOKEN}',
      HELPER: 'Must contain the literal placeholder {TOKEN}.',
    },
    SECURITY_EVENTS_URL: {
      LABEL: 'Security events URL',
      PLACEHOLDER: 'https://…?auth_token={TOKEN}',
      HELPER: 'Must contain the literal placeholder {TOKEN}.',
    },
    AGENT_DASHBOARD_URL: {
      LABEL: 'Agent dashboard URL',
      PLACEHOLDER: 'https://…?auth_token={TOKEN}',
      HELPER: 'Must contain the literal placeholder {TOKEN}.',
    },
    USERNAME: {
      LABEL: 'OpenSearch username',
      PLACEHOLDER: 'acme-user01',
    },
    JWT_SECRET: {
      LABEL: 'JWT secret',
      PLACEHOLDER: 'Paste the plain JWT provided by the monitoring team',
      HELPER_EMPTY: 'Required — no secret is currently stored.',
      HELPER_SET: 'A secret is already stored. Leave empty to keep it.',
    },
    AGENT_FILE: {
      LABEL: 'Agent installer (.zip)',
      HELPER_EMPTY: 'Required — no agent installer is currently stored.',
      HELPER_SET: ({ fileName }: { fileName: string }) =>
        `Current file: ${fileName}. Pick a new file to replace it, or leave empty to keep.`,
    },
    SIEM_INDEXER_URL: {
      LABEL: 'SIEM indexer URL',
      PLACEHOLDER: 'https://host:9200',
    },
    SIEM_USERNAME: {
      LABEL: 'SIEM username',
      PLACEHOLDER: 'siem-readonly',
    },
    SIEM_PASSWORD: {
      LABEL: 'SIEM password',
      PLACEHOLDER: 'Paste the indexer password',
      HELPER_EMPTY: 'Required — no password is currently stored.',
      HELPER_SET: 'A password is already stored. Leave empty to keep it.',
    },
    SIEM_SIDEBAR: {
      LABEL: 'Show SIEM in sidebar',
    },
    API_URL: {
      LABEL: 'Wazuh API URL',
      PLACEHOLDER: 'https://host:55000',
    },
    API_USERNAME: {
      LABEL: 'Wazuh API username',
      PLACEHOLDER: 'wazuh-api',
    },
    API_PASSWORD: {
      LABEL: 'Wazuh API password',
      PLACEHOLDER: 'Paste the API password',
      HELPER_EMPTY: 'Optional. Needed for endpoint actions (restart, isolate).',
      HELPER_SET: 'A password is already stored. Leave empty to keep it.',
    },
  },
  SIEM_SECTION: {
    TITLE: 'Security Dashboard (SIEM)',
    DESCRIPTION: 'Per-organization Wazuh indexer connection used by the SIEM dashboard.',
  },
  API_SECTION: {
    TITLE: 'Wazuh API (endpoint actions)',
    DESCRIPTION: 'Per-organization Wazuh server API used to run active responses on endpoints.',
  },
  ERRORS: {
    URL_REQUIRED: 'URL is required',
    URL_INVALID: 'Must be a valid URL containing the {TOKEN} placeholder',
    USERNAME_REQUIRED: 'Username is required',
    JWT_REQUIRED: 'JWT secret is required for first-time configuration',
    AGENT_FILE_REQUIRED: 'An agent installer file is required for first-time configuration',
    AGENT_FILE_TOO_LARGE: 'Agent installer must be 800 MB or smaller',
    AGENT_FILE_WRONG_EXTENSION: 'Agent installer must be a .zip file',
    AGENT_FILE_WRONG_MIME: 'Agent installer must be an application/zip file',
    SAVE_FAILED: 'Error saving monitoring configuration',
    UPLOAD_FAILED: 'Error uploading agent installer',
    FORBIDDEN: 'You are not authorized to perform this action',
    SIEM_URL_INVALID: 'SIEM indexer URL must be a valid URL',
    SIEM_USERNAME_REQUIRED: 'SIEM username is required',
    SIEM_PASSWORD_REQUIRED: 'SIEM password is required for first-time configuration',
  },
  SNACKBAR: {
    SAVED: 'Monitoring configuration saved',
  },
  SAVE: {
    LABEL: 'Save monitoring configuration',
    SAVING: 'Saving...',
  },
}
